import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useParams, useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import { addRoute } from 'workbox-precaching';
import { CreditScore } from '@mui/icons-material';
import { IconButton, Tooltip, TableCell, TextField, Checkbox, FormControlLabel } from '@mui/material';
import { Grid, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import Modal from '@mui/material/Modal';
import { fetchData, deleteData, activateData, updateData, postData } from '../../../apiService';
import { FaTimes } from 'react-icons/fa'; // Example for FontAwesome Icon


function MasterIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const history = useHistory(); // Access the navigation history
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isPayable, setIsPayable] = useState(false);
    const { id } = useParams();

    const { isAuthenticated, companyId, userId, logout, token, permissions } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        fetchtableData();
        setLoading(true);
    }, [isAuthenticated, companyId, token, userId, logout]);

    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredData(data);
        } else {
            const filtered = data.filter(item => item.name && item.name.toLowerCase().includes(searchTerm.toLowerCase()));
            setFilteredData(filtered);
        }
    }, [data, searchTerm]);


    const fetchtableData = async () => {
        setLoading(true); // Show loading screen
        fetchData('MasterApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                    setFilteredData(response.response_data);

                }
                console.log(response);
            })

            .catch((error) => {
                console.error('Error fetching Item Details:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    };

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const closeModal = () => {
        console.log('Closing modal');
        setOpen(false);
    };


    const handleDelete = async () => {
        deleteData('MasterApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData(); // Refresh data after deletion
                setDeleteItemId(null); // Reset the item ID
                setConfirmDialogOpen(false); // Close the dialog
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });

    };

    const handleActivate = (itemId) => {
        activateData('MasterApi', `${itemId}`)
            .then(() => {
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    //use this as UserType Dropdown
    const [userTypeOptions, setuserTypeOptions] = useState([]);
    const [selectedUserType, setSelectedUserType] = useState("");


    // Fetch UserTypes 
    const fetchUserTypes = async () => {
        try {
            const response = await fetchData('UserTypeApi', `/${companyId}`, token);

            if (response.responseCode === '1111') {
                const options = response.response_data.map(usertype => ({
                    value: usertype.id,
                    label: usertype.name
                }));

                setuserTypeOptions(options);
            }

            console.log(response);
        } catch (error) {
            console.error('Error fetching Room Types:', error);
        }
    };



    const handleUserTypeChange = (selectedOption) => {
        if (selectedOption) {
            setSelectedUserType(selectedOption.value);
        }
    };


    // Fetch room types on component mount
    useEffect(() => {
        fetchUserTypes();
    }, []);

    const [name, setName] = useState("");
    const [address, setAddress] = useState("");
    const [phone, setPhone] = useState(""); // no 1
    const [phoneno, setPhoneNo] = useState(""); // no 2
    const [email, setemail] = useState("");
    const [opening, setopening] = useState("");
    const [creditdays, setcreditdays] = useState("");
    const [gstno, setgstno] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        const CreateData = {
            Name: name,
            GSTNo: gstno,
            Phone1: phone,
            Phone2: phoneno,
            AddressLine1: address,
            Email: email,
            Openingbalance: opening,
            Creditdays: creditdays,
            Ispayable: isPayable,
            UserTypeId: selectedUserType,
            CreatedBy: userId,
            CompanyId: companyId,
            CreatedDate: new Date(),
        };

        postData('MasterApi', CreateData, token)
            .then((response) => {
                console.log('Category Created success:', response);
                setSuccessMessage("Category Created successfully!");
                setErrorMessage("");

                window.location.reload();
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Item Create error:', error);
                setIsLoading(false);
            });
    };

    //MASTER EDIT 
    const [masterEditopen, setMasterEditOpen] = useState(false);


    // update userType dropdown
    const [selectedItemGroup, setSelectedItemGroup] = useState("");
    const [dropdownItemGroupOptions, setDropdownItemGroupOptions] = useState([]);


    useEffect(() => {
        fetchDropdownItemGroupOptions();
    }, []);

    const fetchDropdownItemGroupOptions = () => {
        fetchData('UserTypeApi', `/${companyId}`, token)
            .then((response) => {
                const data = response.response_data;
                if (Array.isArray(data)) {
                    setDropdownItemGroupOptions(data);
                } else {
                    console.error('Unexpected response format:', data);
                    setDropdownItemGroupOptions([]);
                }
            })
            .catch((error) => {
                console.error('Error fetching Item Group dropdown options:', error);
                setDropdownItemGroupOptions([]);
            });
    };

    const handleDropdownChange = (selectedGroupId) => {
        setUpdateData((prevFormData) => ({
            ...prevFormData,
            UserTypeId: selectedGroupId,
        }));
    };



    const handleMasterEditClickOpen = async (id) => {
        try {
            const response = await fetchData('MasterApi', `/MasterDetails/${id}`, token);
            if (response.responseCode === '1111') {
                setUpdateData(response.response_data);
                setMasterEditOpen(true);
                setSelectedItemGroup(response.response_data.userTypeId);
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
        }
    };

    const handleMasterEditClose = () => {
        setMasterEditOpen(false);
    };


    const [updatedData, setUpdateData] = useState({});

    const handleUpdateInputChange = (event) => {
        const { name, value, type, checked } = event.target;
        setUpdateData((prevDataItem) => ({
            ...prevDataItem,
            UserTypeId: selectedItemGroup,
            [name]: type === 'checkbox' ? checked : type === 'radio' ? value === 'true' : value,
        }));
    };

    const updateRecord = async (event) => {
        event.preventDefault();


        try {

            await updateData('MasterApi', `${updatedData.Id}`, updatedData, token);
            setUpdateData({
                Name: '',
                GSTNo: '',
                Phone1: '',
                Phone2: '',
                AddressLine1: '',
                Email: '',
                Openingbalance: '',
                Creditdays: '',
                Ispayable: '',
                UserTypeId: '',
                CompanyId: companyId,

            });

            setMasterEditOpen(false);
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };



    return (
        <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '98%' }}>
            <div className='w-full mb-2 flex'>
                <h5 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>MASTER</h5>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <div>
                            <CircularProgress style={{ color: 'white' }} />
                            <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                        </div>
                    </div>
                )}
                <div className='w-1/4 mb-2 flex'>
                    <input
                        type="text"
                        placeholder="Search by name"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    />
                </div>
                <Tooltip title="New Master Create">

                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        style={{
                            background: 'linear-gradient(to right, brown, red)',
                            color: 'white',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '35px',
                            marginLeft: '5px'
                        }}
                        onClick={handleClickOpen}

                    >
                        Master Create
                    </Button>

                </Tooltip>
                <Modal open={open} className={open ? 'notification-modal' : ''}>
                    <div className="fixed inset-0 flex items-start justify-center z-10">
                        <div className="p-4 sm:p-6 rounded-lg shadow-lg w-full sm:w-3/4 md:w-2/3 lg:w-1/2" style={{ maxHeight: '80vh', overflowY: 'auto', marginTop: '50px', background: 'white' }}>

                            <h6 className="text-center text-black font-bold" style={{ fontFamily: 'Times New Roman' }}>MASTER CREATE</h6>

                            <div className="mt-4">
                                <Grid container spacing={2}>

                                    <Grid container item spacing={2} xs={12}>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl variant="outlined" fullWidth margin="dense">
                                                <InputLabel>User Type</InputLabel>
                                                <Select
                                                    value={selectedUserType}
                                                    onChange={(e) => setSelectedUserType(e.target.value)}
                                                    label="User Type"
                                                >
                                                    {userTypeOptions.map(option => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={8}>
                                            <TextField
                                                margin="dense"
                                                label="Name"
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </Grid>

                                    </Grid>

                                    <Grid container item spacing={2} xs={12}>
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                margin="dense"
                                                label="ContactNumber1"
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                value={phone}
                                                onChange={(e) => setPhone(e.target.value)}

                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                margin="dense"
                                                label="ContactNumber2"
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                value={phoneno}
                                                onChange={(e) => setPhoneNo(e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                margin="dense"
                                                label="GST No"
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                value={gstno}
                                                onChange={(e) => setgstno(e.target.value)}
                                            />
                                        </Grid>


                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            margin="dense"
                                            label="Address"
                                            type="text"
                                            fullWidth
                                            variant="outlined"
                                            multiline
                                            rows={2}
                                            value={address}
                                            onChange={(e) => setAddress(e.target.value)}
                                        />
                                    </Grid>
                                    <Grid container item spacing={2} xs={12}>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                margin="dense"
                                                label="Email"
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                value={email}
                                                onChange={(e) => setemail(e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <TextField
                                                margin="dense"
                                                label="Opening Balance"
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                value={opening}
                                                onChange={(e) => setopening(e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <FormControlLabel style={{ marginTop: '10px' }}
                                                control={
                                                    <Checkbox
                                                        checked={isPayable}
                                                        onChange={(e) => setIsPayable(e.target.checked)}
                                                        color="primary"
                                                    />
                                                }
                                                label="Is Payable"
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container item spacing={2} xs={12}>
                                        <Grid item xs={12} sm={3}>
                                            <TextField
                                                margin="dense"
                                                label="CreditDays"
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                value={creditdays}
                                                onChange={(e) => setcreditdays(e.target.value)}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </div>
                            <DialogActions>
                                <Button onClick={handleSubmit} style={{ backgroundColor: 'green', color: 'white' }}>
                                    Submit
                                </Button>
                                <Button onClick={handleClose} style={{ backgroundColor: 'red', color: 'white' }}>
                                    Close
                                </Button>

                            </DialogActions>
                        </div>
                    </div>
                </Modal>


                <Modal open={masterEditopen} className={masterEditopen ? 'notification-modal' : ''}>
                    <div className="fixed inset-0 flex items-start justify-center z-10">
                        <h6 className="text-center text-black font-bold" style={{ fontFamily: 'Times New Roman' }}>MASTER EDIT</h6>

                        <div className="fixed inset-0 flex items-center justify-center z-10">
                            <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '50%' }}>
                                <h6 className="text-center text-black font-bold" style={{ fontFamily: 'Times New Roman' }}>MASTER EDIT</h6>

                                <div className="w-full mb-4 flex">
                                    <div className="w-3/4 mr-2">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                            Name
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                            type="text"
                                            name="name"
                                            placeholder="Enter Name"
                                            value={updatedData.name}
                                            onChange={handleUpdateInputChange}
                                        />
                                    </div>


                                    {/* <div className="w-1/4 mr-2">

                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                            User Type
                                        </label>
                                      
                                        <Select
                                            value={selectedUserType || (updatedData.Usertypedetails ? { value: updatedData.usertypedetails, label: updatedData.Usertypedetails } : '')}
                                            onChange={handleUserTypeChange}
                                            options={userTypeOptions}
                                            placeholder="Select User Type"
                                            style={{ width: '100%', height: '40px' }}
                                            isSearchable
                                        />
                                    </div> */}
                                    <div className="w-1/4 mr-2">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                            User Type
                                        </label>

                                        <select
                                            className={`custom-select ${selectedItemGroup ? 'fade-in' : 'fade-in'}`}
                                            value={selectedItemGroup || ''}
                                            onChange={(e) => handleDropdownChange(e.target.value)}
                                        >
                                            <option value="">Select User Type</option>
                                            {dropdownItemGroupOptions.map((category) => (
                                                <option key={category.id} value={category.id}>
                                                    {category.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                </div>

                                <div className="w-full mb-4 flex">

                                    <div className="w-1/10 mr-2">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                            ContactNumber 1
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-Center"
                                            type="text"
                                            name="phone1"
                                            placeholder="Enter phone1"
                                            value={updatedData.phone1}
                                            onChange={handleUpdateInputChange}
                                        />
                                    </div>
                                    <div className="w-1/10 mr-2">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MinimumStock">
                                            ContactNumber 2
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                            type="text"
                                            name="phone2"
                                            placeholder="phone2"
                                            value={updatedData.phone2}
                                            onChange={handleUpdateInputChange}
                                        />
                                    </div>
                                    <div className="w-1/10 mr-2">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                            Email
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                            type="text"
                                            name="email"
                                            placeholder="Enter Email"
                                            value={updatedData.email}
                                            onChange={handleUpdateInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="w-full mb-4 flex">
                                    <div className="w-1/2 mr-2" style={{ width: '100%' }}>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                            Address
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                            name="addressLine1"
                                            placeholder="Enter AddressLine"
                                            value={updatedData.addressLine1}
                                            onChange={handleUpdateInputChange}
                                        />
                                    </div>
                                </div>

                                <div className="w-full mb-4 flex">

                                    <div className="w-1/10 mr-2">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="OpeningStock">
                                            GSTNo
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                            type="text"
                                            name="gstno"
                                            placeholder="Enter GSTNo"
                                            value={updatedData.gstNo}
                                            onChange={handleUpdateInputChange}
                                        />
                                    </div>
                                    <div className="w-1/10 mr-2">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="OpeningStock">
                                            Opening Balance
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                            type="text"
                                            name="openingbalance"
                                            placeholder="Enter Opening Balance"
                                            value={updatedData.openingbalance}
                                            onChange={handleUpdateInputChange}
                                        />
                                    </div>
                                    <div className="w-1/4 mr-2">
                                        <div className="inline-flex items-center">
                                            <input
                                                type="checkbox"
                                                className="form-checkbox h-4 w-4 text-green-500 border-4 border-gray-400 rounded-md checked:bg-green-500 checked:border-transparent"
                                                name="ispayable"
                                                checked={updatedData.ispayable}
                                                onChange={handleUpdateInputChange}
                                                style={{ marginTop: '35px', marginLeft: '20px' }}
                                            />
                                            <span className="ml-2" style={{ marginTop: '35px' }}>Is Payable?</span>
                                        </div>
                                    </div>
                                    <div className="w-1/10 mr-2">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="TotalStock">
                                            Credit Days
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                            type="text"
                                            name="creditdays"
                                            placeholder="Credit Days"
                                            value={updatedData.creditdays}
                                            onChange={handleUpdateInputChange}
                                        />
                                    </div>



                                </div>
                                {/* end here */}
                                <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                                    {hasEditMasterPermission && (
                                        <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={updateRecord}>
                                            Update Record
                                        </button>
                                    )}
                                    <button className="bg-blue-500 text-white px-4 py-2 rounded  ml-2" onClick={handleMasterEditClose}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>


                    </div>
                </Modal>
            </div>



            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    {/* <Table> */}
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: 'teal' }}>

                            <TableRow>
                                <TableCell sx={{ backgroundColor: 'teal', borderBottom: '1px solid #F5F5F5', width: '150px', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Type</TableCell>
                                <TableCell sx={{ backgroundColor: 'teal', borderBottom: '1px solid #F5F5F5', width: '150px', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Name</TableCell>
                                <TableCell sx={{ backgroundColor: 'teal', borderBottom: '1px solid #F5F5F5', width: '150px', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Phone</TableCell>
                                <TableCell sx={{ backgroundColor: 'teal', borderBottom: '1px solid #F5F5F5', width: '150px', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Address</TableCell>
                                <TableCell sx={{ backgroundColor: 'teal', borderBottom: '1px solid #F5F5F5', width: '150px', color: 'white', fontWeight: 'bolder', padding: '5px' }}>GST NO</TableCell>
                                <TableCell sx={{ backgroundColor: 'teal', backgroundColor: 'teal', borderBottom: '1px solid #F5F5F5', width: '150px', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Opening</TableCell>
                                <TableCell sx={{ backgroundColor: 'teal', borderBottom: '1px solid #F5F5F5', width: '150px', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Credit Days</TableCell>
                                <TableCell sx={{ backgroundColor: 'teal', borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody style={{ backgroundColor: 'white' }}>

                            {filteredData.map((item, index) => (
                                <TableRow key={item.id} className={item.isActive ? '' : 'inactiveRow'} sx={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#e0e0e0' }} >

                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', width: '7%' }}>{item.usertypedetails}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', width: '20%' }}>{item.name}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', width: '20%' }}>{item.phone1} , {item.phone2}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', width: '20%' }}>{item.addressLine1}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', width: '7%' }}>{item.gstNo}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', width: '7%' }}>{item.openingbalance}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', width: '7%' }}>{item.creditdays}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', height: '40px', padding: '5px', color: 'black', width: '15%' }}>

                                        {hasEditMasterPermission && (

                                            <Tooltip title="Master Edit">
                                                <IconButton onClick={() => handleMasterEditClickOpen(item.id)}>
                                                    <EditIcon style={{ color: 'blueviolet' }} />
                                                </IconButton>
                                            </Tooltip>

                                        )}
                                        {hasDeleteMasterPermission && (
                                            <IconButton onClick={() => (item.isActive ? openConfirmDialog(item.id) : handleActivate(item.id))}>
                                                {item.isActive ? <DeleteIcon style={{ color: 'brown' }} /> : <ActivateIcon />}
                                            </IconButton>
                                        )}

                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete ?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>
                    </Table>
                </TableContainer>
            </div>
        </div >
    );
}

export default MasterIndex;

